import locale from 'live/init/global-locale'

try {
    const i18n = require('live/services/i18n')
    const ptBr = require('./i18n/pt_br')
    const enUs = require('./i18n/en_us')
    
    const localeFiles = {
        pt_br: ptBr,
        en_us: enUs
    }
    
    i18n.add(localeFiles[locale])
} catch (e) {
}
